import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class QueuesService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * List all dead-letter queues
     * @returns string OK. Returns an array of dead-letter queue names.
     * @throws ApiError
     */
    listDeadLetterQueues(options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/queues', errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete messages from dead-letter queue
     * @returns void
     * @throws ApiError
     */
    purgeQueue({ queueName, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/queues/{queueName}', path: {
                'queueName': queueName,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Resend messages from the dead-letter queue
     * @returns RedeliverQueueMessages OK.
     * @throws ApiError
     */
    redeliverMessages({ queueName, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/queues/{queueName}/redeliver', path: {
                'queueName': queueName,
            }, body: requestBody, mediaType: 'application/json', errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=QueuesService.js.map